import { useCallback } from "react";
import { ViewsApi, useAPIAction } from "melco-shared-logic";

export interface MachineStatusViewEditInterface {
  id: string;
  melcoMachineStatisticsModelsUpdateGroup: {
    name: string;
    machine_list: [];
  };
}

export const useMachineStatusViewEdit = () => {
  const [MachineStatusViewEdit] = useAPIAction(
    ViewsApi,
    async (api: ViewsApi, MachineStatusViewEditDetails: any) => {
      const { id, name, group_list, grouped_display } =
        MachineStatusViewEditDetails;

      let data = await api.statisticalViewEdit({
        id: id,
        reportingMelcoMachineStatisticsModelsUpdateView: {
          name: name,
          group_list: group_list,
          grouped_display: grouped_display,
        },
      });

      return {
        data,
        successMessages: [{ message: "default" }],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "reporting.machinestatus.view.actions.update",
    }
  );

  return useCallback(
    async (MachineStatusViewEditDetails: any) => {
      return await MachineStatusViewEdit(MachineStatusViewEditDetails);
    },
    [MachineStatusViewEdit]
  );
};
